import React from 'react';
import { Container } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RowStyled, ColStyled, FlexWrapperStyled } from './styled';
export function SpecificationsSkeleton() {
    const { isMobileView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(RowStyled, null,
            React.createElement(ColStyled, null,
                React.createElement(FlexWrapperStyled, { isFullWidth: true, flexDirection: "column", bg: colorCoreWhite1000, pl: "16px", pr: "16px" },
                    React.createElement(FlexWrapper, { justifyContent: "space-between", alignItems: "center" },
                        React.createElement(Skeleton, { skeletonProps: {
                                height: isMobileView ? 24 : 32,
                                width: isMobileView ? 200 : 300,
                            }, withWrapper: false }),
                        !isMobileView && (React.createElement(Skeleton, { skeletonProps: {
                                height: 20,
                                width: 230,
                                inline: true,
                            }, withWrapper: false }))),
                    React.createElement(Skeleton, { skeletonProps: {
                            height: 44,
                            width: isMobileView ? '100%' : 340,
                        }, wrapperProps: {
                            mtS: 16,
                            mtM: 32,
                        } }),
                    React.createElement(Skeleton, { skeletonProps: {
                            height: isMobileView ? 800 : 600,
                        }, wrapperProps: {
                            mtS: 32,
                        } }),
                    isMobileView && (React.createElement(FlexWrapper, { mt: "24px", isFullWidth: true, justifyContent: "center" },
                        React.createElement(Skeleton, { skeletonProps: {
                                height: 32,
                                width: 230,
                            }, withWrapper: false }))))))));
}
